<template>
    <object type="image/svg+xml" data="/podofit-animation-loader.svg"></object>
</template>
